import React, { useEffect, useState } from 'react';
import { is, has } from '../../services';
import { Icon, IconName, IconSize } from '../icon';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Product Tour Component
 * @param children {React.ReactNode} Title child
 * @param className {string} Additionnal css classes
 * @param active {boolean} Display component
 * @param arrowDirection {ArrowDirection} UP|BOTTOM||LEFT|RIGHT - Display arrow
 * @param arrowAlign {ArrowAlign} ONE_FIFTH|ONE_QUARTER|ONE_THRID|TWO_FIFTHS|THREE_FIFTHS|
 * TWO_THIRDS|THREE_QUARTERS|FOUR_FIFTHS
 * @param closeable {boolean} Display close icon
 * @param avatarSrc {string} Display avatar if source
 * @param avatarDirection {AvatarDirection} LEFT|RIGHT
 */
const ProductTour = ({ children, className, active, arrowDirection, arrowAlign, closeable, avatarSrc, avatarDirection, ...others }) => {
    const [display, setDisplay] = useState(active || false);
    const { styled } = useTrilogyContext();
    useEffect(() => {
        setDisplay(active || false);
    }, [active]);
    const classes = hashClass(styled, clsx('product-tour', display && is('active'), avatarDirection && has(`icon-${avatarDirection}`), className));
    return (React.createElement("div", { className: classes, ...others },
        arrowDirection && (React.createElement("div", { className: hashClass(styled, clsx('arrow', is(arrowDirection), arrowAlign && is(arrowAlign))) })),
        avatarSrc && (React.createElement("span", { className: hashClass(styled, clsx('icon', is('medium'))) },
            React.createElement("img", { className: hashClass(styled, clsx(is('rounded'))), src: avatarSrc }))),
        closeable && (React.createElement("div", { style: { cursor: 'pointer' }, onClick: () => setDisplay(!display) },
            React.createElement(Icon, { size: IconSize.SMALL, name: IconName.TIMES, className: 'close' }))),
        React.createElement("div", { className: hashClass(styled, clsx('product-tour-content')) }, children)));
};
export default ProductTour;
//# sourceMappingURL=ProductTour.js.map